import { DEFAULT_SITE_URL, toSiteUrl } from "./site";

export type StaticPageSeoLink = {
  key: string;
  rel: "canonical" | "alternate";
  href: string;
  hreflang?: "en" | "de" | "x-default";
};

export function getStaticPageSeoLinks(
  pagePath: string,
  locale: string,
  siteUrl = DEFAULT_SITE_URL,
): StaticPageSeoLink[] {
  const normalizedPath = pagePath.startsWith("/") ? pagePath : `/${pagePath}`;
  const englishUrl = toSiteUrl(normalizedPath, siteUrl);
  const germanPath = normalizedPath === "/" ? "/de" : `/de${normalizedPath}`;
  const germanUrl = toSiteUrl(germanPath, siteUrl);

  return [
    {
      key: "static-page-canonical",
      rel: "canonical",
      href: locale === "de" ? germanUrl : englishUrl,
    },
    {
      key: "static-page-alternate-en",
      rel: "alternate",
      hreflang: "en",
      href: englishUrl,
    },
    {
      key: "static-page-alternate-de",
      rel: "alternate",
      hreflang: "de",
      href: germanUrl,
    },
    {
      key: "static-page-alternate-default",
      rel: "alternate",
      hreflang: "x-default",
      href: englishUrl,
    },
  ];
}
